import { FileCopy } from '@mui/icons-material'
import { Button, Tooltip } from '@mui/material'
import type { PreviewButtonProps } from './Buttons'

export const CloneButton = (props: PreviewButtonProps) => {
  const { searchResultItem, hasPartialMedia, visible } = props
  const url = `${window.location.origin}/AddMedia/Index?action=clone&id=`
  const mediaCode = searchResultItem.mediaCode
  const href = url + mediaCode
  const title = hasPartialMedia
    ? 'Cannot edit or clone while you have a partial media'
    : 'Clone Media'

  if (!visible) return null

  return (
    <Tooltip title={title} placement="top">
      <span>
        <Button component="a" disabled={hasPartialMedia} href={href}>
          <FileCopy />
        </Button>
      </span>
    </Tooltip>
  )
}
